export const ADD = 'flight/ADD';
export const REMOVE = 'flight/REMOVE';